import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { useVivliConfigContext } from '@vivli/core/infrastructure/context';

interface ChatDescriptionComponentProps {
    activeChannelName: string;
    activeChannelId: string;
}

const OPEN_CHAT_BASE_TEXT = 'Communicate with Vivli staff, the Data Contributors, Independent Review Panel and the Research Team.';
// CT only: appended to set Agentic AI chat response-time expectations (DEV-670 / RQ-419). Not shown for AMR.
const OPEN_CHAT_CT_RESPONSE_TIME_TEXT =
    ' During Draft and Form Check periods, AI-assisted chat is available to research team members, and responses may appear very quickly. Later in the Data Request cycle, or when a researcher has requested Human Review during an AI-assisted chat period, the human response will take more time.';

export const ChatDescriptionComponent = ({ activeChannelName, activeChannelId }: ChatDescriptionComponentProps) => {
    const { isAmr } = useAssignedAppTypeContext();
    const isOpenChat = activeChannelName === 'Open Chat';
    const isContributorsChat = activeChannelName === 'Contributors';
    const vivliConfig = useVivliConfigContext();
    const aiAssistanceChat = vivliConfig?.aiAssistanceChat;

    const getDisplay = () => {
        let chatText = '';
        if (!activeChannelId) {
            return chatText;
        }
        if (isOpenChat) {
            chatText = isAmr || !aiAssistanceChat ? OPEN_CHAT_BASE_TEXT : OPEN_CHAT_BASE_TEXT + OPEN_CHAT_CT_RESPONSE_TIME_TEXT;
        }
        if (isContributorsChat) {
            chatText = isAmr
                ? 'Communicate with all data contributors and Vivli, but not the requester.'
                : 'Communicate with all data contributors and Vivli, but not the requester or IRPs.';
        }

        return chatText;
    };

    return <span>{getDisplay()}</span>;
};
